export {default} from './SearchGlobal';
